export {default} from './SearchGlobal';
